import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createFastDomNode } from '../../../base/browser/fastDomNode.js';
import { Configuration } from '../config/configuration.js';
import { VisibleLinesCollection } from './viewLayer.js';
import { ViewPart } from './viewPart.js';
export var ViewOverlays = /*#__PURE__*/function (_ViewPart) {
  _inherits(ViewOverlays, _ViewPart);

  var _super = _createSuper(ViewOverlays);

  function ViewOverlays(context) {
    var _this;

    _classCallCheck(this, ViewOverlays);

    _this = _super.call(this, context);
    _this._visibleLines = new VisibleLinesCollection(_assertThisInitialized(_this));
    _this.domNode = _this._visibleLines.domNode;
    _this._dynamicOverlays = [];
    _this._isFocused = false;

    _this.domNode.setClassName('view-overlays');

    return _this;
  }

  _createClass(ViewOverlays, [{
    key: "shouldRender",
    value: function shouldRender() {
      if (_get(_getPrototypeOf(ViewOverlays.prototype), "shouldRender", this).call(this)) {
        return true;
      }

      for (var i = 0, len = this._dynamicOverlays.length; i < len; i++) {
        var dynamicOverlay = this._dynamicOverlays[i];

        if (dynamicOverlay.shouldRender()) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ViewOverlays.prototype), "dispose", this).call(this);

      for (var i = 0, len = this._dynamicOverlays.length; i < len; i++) {
        var dynamicOverlay = this._dynamicOverlays[i];
        dynamicOverlay.dispose();
      }

      this._dynamicOverlays = [];
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this.domNode;
    } // ---- begin IVisibleLinesHost

  }, {
    key: "createVisibleLine",
    value: function createVisibleLine() {
      return new ViewOverlayLine(this._context.configuration, this._dynamicOverlays);
    } // ---- end IVisibleLinesHost

  }, {
    key: "addDynamicOverlay",
    value: function addDynamicOverlay(overlay) {
      this._dynamicOverlays.push(overlay);
    } // ----- event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      this._visibleLines.onConfigurationChanged(e);

      var startLineNumber = this._visibleLines.getStartLineNumber();

      var endLineNumber = this._visibleLines.getEndLineNumber();

      for (var lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
        var line = this._visibleLines.getVisibleLine(lineNumber);

        line.onConfigurationChanged(e);
      }

      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return this._visibleLines.onFlushed(e);
    }
  }, {
    key: "onFocusChanged",
    value: function onFocusChanged(e) {
      this._isFocused = e.isFocused;
      return true;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return this._visibleLines.onLinesChanged(e);
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return this._visibleLines.onLinesDeleted(e);
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return this._visibleLines.onLinesInserted(e);
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return this._visibleLines.onScrollChanged(e) || true;
    }
  }, {
    key: "onTokensChanged",
    value: function onTokensChanged(e) {
      return this._visibleLines.onTokensChanged(e);
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return this._visibleLines.onZonesChanged(e);
    } // ----- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      var toRender = this._dynamicOverlays.filter(function (overlay) {
        return overlay.shouldRender();
      });

      for (var i = 0, len = toRender.length; i < len; i++) {
        var dynamicOverlay = toRender[i];
        dynamicOverlay.prepareRender(ctx);
        dynamicOverlay.onDidRender();
      }
    }
  }, {
    key: "render",
    value: function render(ctx) {
      // Overwriting to bypass `shouldRender` flag
      this._viewOverlaysRender(ctx);

      this.domNode.toggleClassName('focused', this._isFocused);
    }
  }, {
    key: "_viewOverlaysRender",
    value: function _viewOverlaysRender(ctx) {
      this._visibleLines.renderLines(ctx.viewportData);
    }
  }]);

  return ViewOverlays;
}(ViewPart);
export var ViewOverlayLine = /*#__PURE__*/function () {
  function ViewOverlayLine(configuration, dynamicOverlays) {
    _classCallCheck(this, ViewOverlayLine);

    this._configuration = configuration;
    this._lineHeight = this._configuration.options.get(51
    /* lineHeight */
    );
    this._dynamicOverlays = dynamicOverlays;
    this._domNode = null;
    this._renderedContent = null;
  }

  _createClass(ViewOverlayLine, [{
    key: "getDomNode",
    value: function getDomNode() {
      if (!this._domNode) {
        return null;
      }

      return this._domNode.domNode;
    }
  }, {
    key: "setDomNode",
    value: function setDomNode(domNode) {
      this._domNode = createFastDomNode(domNode);
    }
  }, {
    key: "onContentChanged",
    value: function onContentChanged() {// Nothing
    }
  }, {
    key: "onTokensChanged",
    value: function onTokensChanged() {// Nothing
    }
  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      this._lineHeight = this._configuration.options.get(51
      /* lineHeight */
      );
    }
  }, {
    key: "renderLine",
    value: function renderLine(lineNumber, deltaTop, viewportData, sb) {
      var result = '';

      for (var i = 0, len = this._dynamicOverlays.length; i < len; i++) {
        var dynamicOverlay = this._dynamicOverlays[i];
        result += dynamicOverlay.render(viewportData.startLineNumber, lineNumber);
      }

      if (this._renderedContent === result) {
        // No rendering needed
        return false;
      }

      this._renderedContent = result;
      sb.appendASCIIString('<div style="position:absolute;top:');
      sb.appendASCIIString(String(deltaTop));
      sb.appendASCIIString('px;width:100%;height:');
      sb.appendASCIIString(String(this._lineHeight));
      sb.appendASCIIString('px;">');
      sb.appendASCIIString(result);
      sb.appendASCIIString('</div>');
      return true;
    }
  }, {
    key: "layoutLine",
    value: function layoutLine(lineNumber, deltaTop) {
      if (this._domNode) {
        this._domNode.setTop(deltaTop);

        this._domNode.setHeight(this._lineHeight);
      }
    }
  }]);

  return ViewOverlayLine;
}();
export var ContentViewOverlays = /*#__PURE__*/function (_ViewOverlays) {
  _inherits(ContentViewOverlays, _ViewOverlays);

  var _super2 = _createSuper(ContentViewOverlays);

  function ContentViewOverlays(context) {
    var _this2;

    _classCallCheck(this, ContentViewOverlays);

    _this2 = _super2.call(this, context);
    var options = _this2._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this2._contentWidth = layoutInfo.contentWidth;

    _this2.domNode.setHeight(0);

    return _this2;
  } // --- begin event handlers


  _createClass(ContentViewOverlays, [{
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._contentWidth = layoutInfo.contentWidth;
      return _get(_getPrototypeOf(ContentViewOverlays.prototype), "onConfigurationChanged", this).call(this, e) || true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return _get(_getPrototypeOf(ContentViewOverlays.prototype), "onScrollChanged", this).call(this, e) || e.scrollWidthChanged;
    } // --- end event handlers

  }, {
    key: "_viewOverlaysRender",
    value: function _viewOverlaysRender(ctx) {
      _get(_getPrototypeOf(ContentViewOverlays.prototype), "_viewOverlaysRender", this).call(this, ctx);

      this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
    }
  }]);

  return ContentViewOverlays;
}(ViewOverlays);
export var MarginViewOverlays = /*#__PURE__*/function (_ViewOverlays2) {
  _inherits(MarginViewOverlays, _ViewOverlays2);

  var _super3 = _createSuper(MarginViewOverlays);

  function MarginViewOverlays(context) {
    var _this3;

    _classCallCheck(this, MarginViewOverlays);

    _this3 = _super3.call(this, context);
    var options = _this3._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    _this3._contentLeft = layoutInfo.contentLeft;

    _this3.domNode.setClassName('margin-view-overlays');

    _this3.domNode.setWidth(1);

    Configuration.applyFontInfo(_this3.domNode, options.get(36
    /* fontInfo */
    ));
    return _this3;
  }

  _createClass(MarginViewOverlays, [{
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      Configuration.applyFontInfo(this.domNode, options.get(36
      /* fontInfo */
      ));
      var layoutInfo = options.get(117
      /* layoutInfo */
      );
      this._contentLeft = layoutInfo.contentLeft;
      return _get(_getPrototypeOf(MarginViewOverlays.prototype), "onConfigurationChanged", this).call(this, e) || true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return _get(_getPrototypeOf(MarginViewOverlays.prototype), "onScrollChanged", this).call(this, e) || e.scrollHeightChanged;
    }
  }, {
    key: "_viewOverlaysRender",
    value: function _viewOverlaysRender(ctx) {
      _get(_getPrototypeOf(MarginViewOverlays.prototype), "_viewOverlaysRender", this).call(this, ctx);

      var height = Math.min(ctx.scrollHeight, 1000000);
      this.domNode.setHeight(height);
      this.domNode.setWidth(this._contentLeft);
    }
  }]);

  return MarginViewOverlays;
}(ViewOverlays);